module.exports = __webpack_public_path__ + "media/images/icons/marking-93e45f2579f6c13af5ae55d1e62ff469.svg";